import React from 'react';
import PropTypes from 'prop-types';
import withAccountFormStepStyles from 'Components/UI/Accounts/AccountApplication/Step/withAccountFormStepStyles';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import classNames from 'classnames';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import Typography from 'Components/UI/Typography';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { Collapse } from '@mui/material';
import SocialSecurityField from 'Components/UI/Accounts/AccountApplication/Step/Fields/SocialSecurityField';
import { USA } from 'Consts/Apex';
import fr from 'facet-rest';
import VerifyIdentity from 'Components/ComponentLibrary/Organisms/ClientDetailForm/VerifyIdentity/VerifyIdentity';

const hideSecondary = resource => {
  return resource
    .meta()
    .field('secondaryApplicantFirstName')
    .attr('hidden');
};

function PersonalInformation({ classes }) {
  const { resource } = useMetaLayoutContext();
  const needPrimaryVisaInformation = resource.attr('primaryApplicantCitizenshipCountry') !== USA && resource.attr('primaryApplicantIsPermanentResident') === 'false';
  const needSecondaryVisaInformation = resource.attr('secondaryApplicantCitizenshipCountry') !== USA && resource.attr('secondaryApplicantIsPermanentResident') === 'false';
  const isSecondaryHidden = hideSecondary(resource);


  return (
    <div className={classes.root}>
      {resource.withRelationship(fr.relationships.reVerifyIdentity.name,
        (rel) => <div className={classes.row}><VerifyIdentity relationship={rel} /></div>,
        () => null)}
      <div className={classes.row}>
        <Typography
          className={classes.header}
          variant="h3"
          color="primary"
          component={'h2'}
        >{'Primary Applicant'}
        </Typography>
      </div>
      <div className={classes.row}>
        <MetaField attr="primaryApplicantFirstName" />
        <MetaField attr="primaryApplicantLastName" />
      </div>
      <div className={classes.row}>
        <MetaField attr="primaryApplicantDateOfBirth" openTo="year" />
        <SocialSecurityField
          attr="primaryApplicantSsn"
        />
      </div>

      <div className={classes.row}>
        <MetaField
          attr="primaryApplicantCitizenshipCountry"
        />
        <MetaField attr="primaryApplicantIsPermanentResident" />
      </div>
      <Collapse in={needPrimaryVisaInformation}>
        <Box
          className={classes.row}
        >
          <MetaField attr="primaryApplicantBirthCountry" />
          <MetaField attr="primaryApplicantVisaExpirationDate" openTo="year" />
          <MetaField attr="primaryApplicantVisaType" />
        </Box>
      </Collapse>
      <div
        className={classNames(classes.row, {
          [classes.hidden]: isSecondaryHidden,
        })}
      >
        <Typography
          className={classes.header}
          variant="h3"
          color="primary"
          component={'h2'}
        >{'Secondary Applicant'}
        </Typography>
      </div>
      <div className={classes.row}>
        <MetaField attr="secondaryApplicantFirstName" />
        <MetaField attr="secondaryApplicantLastName" />
      </div>
      <div className={classes.row}>
        <MetaField attr="secondaryApplicantDateOfBirth" openTo="year" />
        <SocialSecurityField attr="secondaryApplicantSsn" />
      </div>
      <div className={classes.row}>
        <MetaField
          attr="secondaryApplicantCitizenshipCountry"
        />
        <MetaField attr="secondaryApplicantIsPermanentResident" />
      </div>
      <Collapse in={needSecondaryVisaInformation}>
        <Box
          className={classes.row}
        >
          <MetaField attr="secondaryApplicantBirthCountry" />
          <MetaField attr="secondaryApplicantVisaType" />
          <MetaField attr="secondaryApplicantVisaExpirationDate" openTo="year" />
        </Box>
      </Collapse>
      <div className={classes.row}>
        <MetaField attr="custodialState" />
      </div>
    </div>
  );
}

PersonalInformation.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withAccountFormStepStyles(PersonalInformation);
